/**
 * Fix for vite import compatibility for problematic libs
 * https://github.com/gpbl/react-day-picker/issues/1194
 */
function fixLibImport<T>(importToken: T): T {
  const token: any = importToken;
  return token.__esModule ? token.default : token;
}

export { fixLibImport };
